import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=4e4d52ce&scoped=true"
import script from "./LanguageSwitch.vue?vue&type=script&lang=ts"
export * from "./LanguageSwitch.vue?vue&type=script&lang=ts"
import style0 from "./LanguageSwitch.vue?vue&type=style&index=0&id=4e4d52ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4d52ce",
  null
  
)

export default component.exports